import { type Item } from "./types";

export type WallFace = 0 | 1 | 2 | 3;

/** Corners: +x+z, -x+z, +x-z, -x-z */
export type CornerH = [number, number, number, number];

export const WALL_FACE_LABEL: Record<WallFace, string> = {
  0: "frente",
  1: "derecha",
  2: "fondo",
  3: "izquierda",
};

export function roomBaseY(_item: Item): number {
  return 0;
}

export function roomCorners(item: Item): CornerH {
  if (item.cornerH) return item.cornerH;
  const h = Math.max(0.4, item.height);
  return [h, h, h, h];
}

export function roomHeightRange(item: Item): { min: number; max: number } {
  const c = roomCorners(item);
  return { min: Math.min(...c), max: Math.max(...c) };
}

export function getRoomWallHeight(item: Item, face: WallFace): number {
  const c = roomCorners(item);
  const [a, b] = wallCornerIndex(face);
  return Math.round(((c[a] + c[b]) / 2) * 100) / 100;
}

export function setRoomWallHeight(item: Item, face: WallFace, height: number): void {
  const h = Math.max(0.4, height);
  const c = roomCorners(item);
  const [a, b] = wallCornerIndex(face);
  c[a] = h;
  c[b] = h;
  item.cornerH = c;
  item.height = Math.max(...c);
}

export function setAllRoomWallHeights(item: Item, height: number): void {
  const h = Math.max(0.4, height);
  item.height = h;
  item.cornerH = [h, h, h, h];
}

function wallCornerIndex(face: WallFace): [number, number] {
  if (face === 0) return [0, 1];
  if (face === 1) return [0, 2];
  if (face === 2) return [2, 3];
  return [1, 3];
}
